/** CART DigiLocker OAuth return — public route resumes builder/CP onboard wizard. */
export function superAdminDigilockerRedirectUrl(appOrigin: string): string {
  const base = appOrigin.replace(/\/$/, '');
  return `${base}/digilocker-complete?digilocker_return=1`;
}
